/*
 * サブシステム名：貨物自動車運送事業実績報告
 * 機能名：貨物自動車運送事業実績報告
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'

export default {
  name: 'KamotsujidoshaOutput',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    conditions: {
    },
    modeKengen: 0,
    // 表示制御
    dispCsvNm: '',
    dispPdfNm: '',
    page: 1,
    // ----------------------------------------------------------------------------------------------------
    // 表示制御
    // ----------------------------------------------------------------------------------------------------
    yDisp: false
  }),
  watch: {
    chohyoSbt: function () {
      if (this.conditions.chohyoSbt === '0') {
        this.yDisp = true
      }
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg'
    })
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteLeaveByMenu: function (next) {
    const option = {
      nextCallback: next
    }
    this.preventTransition(option)
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: [],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            // ユーザ保存項目の復元
            resolve()
          })
        },
        existsIdMethod: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★', kengen.kengenKbn)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onCsvButtonClick: function (e) {
      if (!this.clientValidate()) { return }
      this.Effects.loadStart()
      this.clearSummaryMessage()
      let post = ''
      if (this.conditions.chohyoSbt === '0') {
        this.dispCsvNm = `貨物自動車運送事業実績報告_${this.getTimeStamp()}.csv`
        post = '/api/v1/D2bzmp3110/CsvDownload'
      }
      this.HttpClient
        .post(post, this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          this.setInvalidSummaryMessage('COMI0006')
          this.Effects.loadComplete()
        })
    },
    onPdfButtonClick: function (e) {
      if (!this.clientValidate()) { return }
      this.clearSummaryMessage()
      console.log(e)
      this.Effects.loadStart()
      let post = ''
      if (this.conditions.chohyoSbt === '0') {
        this.dispPdfNm = `貨物自動車運送事業実績報告_${this.getTimeStamp()}.pdf`
        post = '/api/v1/D2bzmp3110/PdfDownload'
      }
      this.HttpClient
        .requestFileByPost(post, this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          if (data.type === 'application/pdf') {
            const blob = new Blob([data], { type: 'application/pdf' })
            const elem = document.getElementById('pdfDownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.Effects.loadComplete()
          } else {
            this.setInvalidSummaryMessage('COMI0101')
            this.Effects.loadComplete()
          }
        })
    },
    clientValidate: function () {
      // 指定のrefのみ検証処理
      var refs = []
      refs.push(this.$refs.tekiyoNendo)
      const isvalid = this.validateAll(refs)
      return isvalid
    },
    onClearButtonClick: function () {
      this.initBindVariables()
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      var today = new Date()
      // 年度を算出（1～3月は西暦前年の年度）
      var year = (today.getMonth() + 1) < 4 ? today.getFullYear() - 1 : today.getFullYear()
      var tekiyoNendo = ('000' + year).slice(-4)
      this.conditions = {}
      this.$set(this.conditions, 'tekiyoNendo', tekiyoNendo)
      // 表示制御
      this.$set(this.conditions, 'chohyoSbt', '0')
      this.yDisp = true
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    }
  }
}
